import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M0 0H19V4H0zM0 7H15V11H0z" />
  </React.Fragment>,
  'SideDrawer'
)
